import styled from "styled-components";
import { Space } from "@tvg/design-system";

export const ContentContainer = styled.div<{ space: Space }>`
  display: flex;
  flex-direction: column;
  &:not(:last-child) {
    margin-bottom: ${({ space }) => space["space-5"]};
  }
`;
